import { render, staticRenderFns } from "./OnboardingSection.vue?vue&type=template&id=50930790&scoped=true"
import script from "./OnboardingSection.vue?vue&type=script&lang=ts"
export * from "./OnboardingSection.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingSection.vue?vue&type=style&index=0&id=50930790&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50930790",
  null
  
)

export default component.exports